import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Livecoding #28: Productizing the door-answering Slack bot, Part 1",
  "description": "",
  "published": "2016-12-05T00:00:00.000Z",
  "redirect_from": ["/blog/livecoding-28-productizing-the-door-answering-slack-bot-part1/swizec/7267"],
  "categories": "Front End, Livecoding, react, Technical",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`This is a Livecoding Recap – an almost-weekly post about interesting things discovered while livecoding ?. Always under 500 words and with pictures. You can follow my channel, `}<a parentName="em" {...{
          "href": "https://livecoding.tv/swizec"
        }}>{`here`}</a>{`. New streams almost `}<strong parentName="em">{`every Sunday at 2pm PDT`}</strong>{`. There’s live chat, come say hai ?`}</em></p>
    <p>{`Today was all about winning a bet.`}</p>
    <p>{`On Wednesday, the founder walked up to my desk and said: `}<em parentName="p">{`"If you don't get that Slack bot set up, we're routing the buzzer phone number to your phone. I'm not joking."`}</em></p>
    <p>{`Well, the joke's on him. OpenMyDoor is ready for a real world test! ?? Weight off my chest. too. I hate phones.`}</p>
    <p>{`But first, some background. He was talking about `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/make-slack-twilio-talk/swizec/7128"
      }}>{`the Twilio+Slack bot`}</a>{` I `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/livecoding-22-a-door-answering-slackbot/swizec/7038"
      }}>{`started building`}</a>{`, and `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/livecoding-23-slackbots-oauth/swizec/7065"
      }}>{`almost finished`}</a>{` in September. I had a working prototype running on my localhost some time in October.`}</p>
    <p>{`When I showed it to the coworker who's currently stuck answering the door, she loved it. Super excited. She's been giving me glares for the past 2 months. `}<em parentName="p">{`"Where is my fucking bot!?"`}</em>{` the glares ask.`}</p>
    <p>{`Then I hide under the couch and mumble something about how short nights and weekends are.`}</p>
    <p>{`Founder dude put his foot down, and here we are. Bot is ready 4 days later. ?`}</p>
    <p>{`In my defense, I `}<em parentName="p">{`meant`}</em>{` to do it this whole time, but I was busy putting together the `}<a parentName="p" {...{
        "href": "http://www.reactindiebundle.com"
      }}>{`React Indie Bundle`}</a>{`.`}</p>
    <h2 {...{
      "id": "what-we-did"
    }}>{`What we did`}</h2>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2016/12/Screen-Shot-2016-12-05-at-00.44.43.png",
        "alt": null
      }}></img></p>
    <p>{`Here's what we did to win the bet:`}</p>
    <ul>
      <li parentName="ul">{`put bot on Heroku as `}<a parentName="li" {...{
          "href": "https://openmydoor.herokuapp.com/"
        }}>{`openmydoor.herokuapp.com`}</a></li>
      <li parentName="ul">{`made initiating the OAuth flow easier`}</li>
      <li parentName="ul">{`made API keys and tokens configurable`}</li>
    </ul>
    <p>{`That's right. You can't steal my auth anymore. You may have seen the exact tokens in the video, but I can regenerate and configure them easily. Ha!`}</p>
    <p>{`I should do that…`}</p>
    <p>{`The caveat is that it's still set up to only work with one Slack team at a time. Once you change the config, the bot is theirs.`}</p>
    <p>{`At least it's independent of my laptop now ?`}</p>
    <p>{`To make OpenMyDoor `}<em parentName="p">{`actually`}</em>{` useful, I have to add a database. Something simple to keep track of which OAuth token belongs to which phone number and Slack channel. Then we'll be able to route Twilio calls to correct teams.`}</p>
    <p>{`We'll do that next week on Saturday instead of Sunday because I'm having some sort of Christmas party on Sunday.`}</p>
    <p>{`See you next week. I have the perfect user onboarding flow in mind.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      